import { Draft, PayloadAction }      from '@reduxjs/toolkit';
import { IOrganisationInvoiceState } from 'Redux/Slices/OrganisationInvoice/OrganisationInvoiceSlice';
import { removeActionTypes }         from 'Utils/ReducerUtility';

export const sendOrganisationInvoicePdfRequest = (state: Draft<IOrganisationInvoiceState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const sendOrganisationInvoicePdfSuccess = (state: Draft<IOrganisationInvoiceState>, { type }: PayloadAction) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
};

export const sendOrganisationInvoicePdfFailure = (state: Draft<IOrganisationInvoiceState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
